import { combineReducers } from 'redux';
import application from './application';
import folders from './folders';
import login from './login';
import messages from './messages';
import lexon from './lexon';
import { currentUser } from './user';
import {calendarsResult} from "../calendar/components/sidebar/sidebarCalendar.reducers";

export const INITIAL_STATE = {
  application: {
    title: 'Lefebvre Mail',
    user: {},
    eventFilterKeyword: '',
    newMessage: null,
    selectedFolderId: {},
    messageFilterKey: null,
    loadingFilterMessages: false,
    messageFilterKeyword: null,
    createFolderParentId: null,
    renameFolderId: null,
    selectedMessage: {},
    downloadedMessages: {},
    outbox: null,
    isInvalidAuth: false,
    showSettingsPopover: false,
    showUserSignPopover: false,
    showUserTemplatePopover: false,
    showDefaultCalendarPopover: false,
    draft: null,
    pollInterval: 60000,
    errors: {
      diskQuotaExceeded: false,
      authentication: null
    },
    refreshMessageActiveRequests: 0,
    activeRequests: 0,
    nextcloudUser: false,
    service: null,
    showFilterEventFields: false,
    isFilterDate: false,
    isSearchTopBar: false,
    showPreview: false,
    filtersApplied: {},
    filteredMessages: [],
    searchTotalHits: 0,
    searchFrom: 0,
    searchSize: 50
  },
  folders: {
    items: [],
    explodedItems: {},
    activeRequests: 0,
    showMoveFolderAlert: false,
    firstSyncCompleted: false,
    isUpdatedFolder: false,
    showFolderList: false
  },
  login: {
    formValues: {}
  },
  messages: {
    cache: {},
    selected: [],
    selectedMessages: [],
    locked: [],
    activeRequests: 0,
    sidebarLexonDocked: false,
    sidebarCalendarDocked: false,
    sidebarCentinelaDocked: false,
    sidebarDatabaseDocked: false,
    isFullMessageContent: false
  },
  lexon: {
    user: null,
    idClientLef: null,
    account: null,
    userId: null,
    provider: null,
    isNewAccount: false,
    idCaseFile: null,
    idEmail: null,
    idFolder: null,
    emailShown: null,
    sign: null,
    guid: null,
    idMail: null,
    token: null,
    idActuation: null,
    idEvent: null,
    appConnect: null,
    newIdActuation: null,
    newIdEvent: null,
    isFirstLoad: true,
    lexonToken: null,
    configCalendar: null,
    customerConnectEmail: null,
    documentsId: null,
    tokenWithoutDocument: null,
    interveners: null,
    templates: [],
    firmas: [],
    folders: [],
    subjectEmail: '',
    isCompose: false,
  },
  currentUser: {
    idClienteNavision: null,
    idUserApp: null,
    name: null,
    roles: null,
    sign: null,
    account: null
  },
  calendarsResult: {
    calendars: [],
    calendarTimeScale: {
      enable: true,
      interval: 60,
      slotCount: 6
    },
    calendarError: null
  }
};

export default combineReducers({
  application,
  login,
  folders: folders,
  messages: messages,
  currentUser: currentUser,
  lexon: lexon,
  calendarsResult
});
